import getTypeFromValue from '_utils/helpers/getTypeFromValue';

export enum ItemStyle {
  listingWithImageAndDescription = 'listing-with-image-and-description',
  listingWithImage = 'listing-with-image',
  listingWithDate = 'listing-with-date',
  cardWithDescription = 'card-with-description',
  cardWithoutDescription = 'card-without-description'
}

export const getItemStyle = (value: string | object, key: string = 'type'): ItemStyle => getTypeFromValue<ItemStyle>(ItemStyle, value, key)

export const stylesThatRenderImage = {
  [ItemStyle.listingWithImage]: true,
  [ItemStyle.listingWithImageAndDescription]: true
};

export const stylesThatRenderDate = {
  [ItemStyle.listingWithDate]: true
};

export const stylesThatRenderDescription = {
  [ItemStyle.listingWithImageAndDescription]: true,
  [ItemStyle.cardWithDescription]: true,
  [ItemStyle.listingWithDate]: true
};

export type ItemProps = {
  id: string;
  type: string;
  title: string;
  description?: string | object;
  primaryCategory?: string;
  image: {
    value: {
      src: string;
      alt: string;
      width: string;
      height: string;
    };
  };
  link: string;
  dateNumber?: string;
  dateDay?: string;
  dateMonth?: string;
  attributes: {
    value: string;
    type: string;
  }[];
};

export type ListItemProps = ItemProps & {
  itemStyle: ItemStyle;
  editMode: boolean;
};
